import { httpClient } from '@/core/api/http-client'
import type { Paged } from '@/domain/entities/paging'
import type {
  PaymentInput,
  Transaction,
  TransactionDraft,
  TransactionListParams,
} from '@/domain/entities/transaction.entity'
import type { TransactionRepository } from '@/domain/repositories/transaction.repository'
import { unwrap, unwrapPaged } from '@/infrastructure/shared/unwrap'
import type { TransactionDto } from './transaction.dto'
import { transactionMapper } from './transaction.mapper'

export class TransactionHttpRepository implements TransactionRepository {
  async create(outletId: string, draft: TransactionDraft): Promise<Transaction> {
    const raw = await httpClient.post<unknown>(
      '/transactions',
      transactionMapper.toCreateBody(outletId, draft),
    )
    return transactionMapper.toTransaction(unwrap<TransactionDto>(raw))
  }

  async pay(outletId: string, transactionId: string, input: PaymentInput): Promise<Transaction> {
    // Semua endpoint transaksi selain POST meminta outlet_id lewat QUERY;
    // absen atau bukan UUID dijawab 400.
    const raw = await httpClient.post<unknown>(
      `/transactions/${transactionId}/payments`,
      transactionMapper.toPaymentBody(input),
      { params: { outlet_id: outletId } },
    )
    return transactionMapper.toTransaction(unwrap<TransactionDto>(raw))
  }

  async list(outletId: string, params: TransactionListParams): Promise<Paged<Transaction>> {
    const raw = await httpClient.get<unknown>('/transactions', {
      params: { outlet_id: outletId, page: params.page, limit: params.limit },
    })
    const paged = unwrapPaged<TransactionDto>(raw, params.page, params.limit)
    return { ...paged, items: paged.items.map(transactionMapper.toTransaction) }
  }
}
